import React from 'react';
import Base from './Base';

export default (props) => (
  <Base {...props}>
    <path d="M4.61,13.38A10.46,10.46,0,0,0,15,23.81h0a10.29,10.29,0,0,0,4.48-1l3.64,3.65-5.73,5.77,4.91,4.91,2.08-2.08.57-.57,3.08-3.08,5,4.95-5.74,5.73L32.23,47l2.09-2.08.56-.57L38,41.27l2.51,2.52,4.91-4.91-20.93-21a10.29,10.29,0,0,0,1-4.48,10.43,10.43,0,0,0-20.85,0Zm7,0A3.48,3.48,0,1,1,15,16.9,3.48,3.48,0,0,1,11.56,13.42Z" />
  </Base>
);
